import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from './language/translations.js';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translations.en
      },
      es: {
        translation: translations.es
      },
      vi: {
        translation: translations.vi
      },
      ar: {
        translation: translations.ar
      },
      zh: {
        translation: translations.zh
      },
      prs: {
        translation: translations.prs
      },
      lo: {
        translation: translations.lo
      },
      ti: {
        translation: translations.ti
      },
      km: {
        translation: translations.km
      },
      mam: {
        translation: translations.mam
      }
    },
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
